module.exports = __webpack_public_path__ + "static/media/robot.0c898e7c.png";